<template>
  <b-card class="card-people">
    <h6 v-if="legal_person" class="d-flex border-bottom pb-2">
      <font-awesome-icon icon="city" class="icon-structure mr-3" />
      <div>
        {{ legal_person.fantasy_name }}
        <small class="d-block">{{ legal_person.social_reason }}</small>
      </div>
    </h6>

    <div
      v-for="(person, key) in physical_people"
      :key="key"
      class="d-flex mb-2 physical-person"
    >
      <font-awesome-icon icon="user" class="icon-structure mr-3" />
      <div>
        {{ person.name }}
        <small class="d-block">{{ person.pivot.role }}</small>
      </div>

      <b-button
        @click="remove_physical_person(person)"
        size="sm"
        variant="light"
        class="ml-auto mr-2 p-0 bt-action text-danger"
      >
        <font-awesome-icon icon="trash" />
      </b-button>
    </div>
  </b-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    structure_item: {
      type: Object,
    },
  },
  computed: {
    legal_person() {
      return this.structure_item.legal_person;
    },
    physical_people() {
      return this.structure_item.physical_people;
    },
  },
  methods: {
    ...mapActions("organizational_structures", ["ActionRemovePhysicalPeople"]),
    async remove_physical_person(person) {
      let payload = {
        id: this.structure_item.id,
        physical_person_id: person.id,
      };
      await this.ActionRemovePhysicalPeople(payload);
    },
  },
};
</script>

<style lang="scss">
.card-people {
  .physical-person {
    .bt-action {
      opacity: 0;
      transition: all 0.3s;
    }

    &:hover {
      .bt-action {
        opacity: 1;
      }
    }
  }
}
</style>
